export const usbDeviceReducer = (state = null, action) => {
    switch (action.type) {
      case 'SET_USB_DEVICE':
        return action.payload;
      default:
        return state;
    }
  };
